<template>
  <div class="layout-footer">
    <div class="p-d-flex p-flex-row p-justify-between p-grid">
      <div class="p-col-12 p-md-4">
        <span class="footer-text" style="margin-right: 5px; font-weight: bold;"
          >HRD Smart &copy; 2021</span
        >
        <!-- <img src="assets/layout/images/logo.svg" alt="sigma" width="80" /> -->
        <!-- <span class="footer-text" style="margin-left: 5px">HRD Smart</span> -->
      </div>

      <div class="p-col-12 p-md-8 p-d-flex p-justify-end">
        <span class="p-ml-6 footer-text policy-link" @click="popupHowto"
          >คู่มือการใช้งาน</span
        >
        <span
          class="p-ml-6 footer-text policy-link"
          style="margin-right: 50px"
          @click="popupPersonalPolicy"
          >Privacy Policy</span
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { usePlugin } from "./plugins";
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppFooter",
  setup() {
    const { popupPersonalPolicy } = usePlugin();

    const popupHowto = () => {
      window.open(
        "https://1drv.ms/w/s!Aq-p8jdGudbMl44E0yIONoNnmP-QJA?e=OTuoYR",
        "blank"
      );
    };
    return {
      popupPersonalPolicy,
      popupHowto,
    };
  },
});
</script>

<style scoped>
.policy-link {
  cursor: pointer;
  text-decoration: underline;
}
</style>
